import * as React from "react";
const SvgNoFolders = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 137.498,
	height: 97.329,
	viewBox: "0 0 137.498 97.329",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_23",
	"data-name": "Group 23",
	transform: "translate(-1086 -336.799)"
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_22",
	"data-name": "Group 22",
	transform: "translate(20.44 -73.95)"
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_14",
	"data-name": "Group 14",
	transform: "translate(1065.56 383.947)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_499",
	"data-name": "Path 499",
	d: "M442.2,381.61a.756.756,0,0,0-.372.13,11.107,11.107,0,0,0,1.665-.231Z",
	transform: "translate(-393.645 -331.766)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_501",
	"data-name": "Path 501",
	d: "M364.676,494.922",
	transform: "translate(-332.608 -421.489)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_507",
	"data-name": "Path 507",
	d: "M427.115,497.083h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -421.044)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_508",
	"data-name": "Path 508",
	d: "M432.732,519.086H384.245a1.362,1.362,0,1,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -438.452)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_509",
	"data-name": "Path 509",
	d: "M427.115,569.656h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-347.013 -478.459)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_510",
	"data-name": "Path 510",
	d: "M432.732,591.659H384.245a1.362,1.362,0,0,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -495.866)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_517",
	"data-name": "Path 517",
	d: "M125.842,339.408H128.4l1.218-9.877h-3.78Z",
	transform: "translate(-99.556 -260.701)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_518",
	"data-name": "Path 518",
	d: "M333.868,516.174h5.043a3.214,3.214,0,0,1,3.214,3.214v.1h-8.257Z",
	transform: "translate(-308.235 -438.302)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_519",
	"data-name": "Path 519",
	d: "M30.551,330.254l2.653.519,3.264-9.986-3.916-.766Z",
	transform: "translate(-24.169 -253.177)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_520",
	"data-name": "Path 520",
	d: "M236.727,507.59l5.225,1.022h0a3.393,3.393,0,0,1,2.678,3.981l-.021.108-8.555-1.673Z",
	transform: "translate(-230.853 -431.511)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_526",
	"data-name": "Path 526",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_527",
	"data-name": "Path 527",
	d: "M336.023,478.554H234.477a3.329,3.329,0,0,1-3.325-3.325V417.7a3.329,3.329,0,0,1,3.325-3.325,2.944,2.944,0,0,1,2.941,2.941V471.26a3.12,3.12,0,0,0,3.116,3.116H335.68a2.115,2.115,0,0,1,2.071,1.585,2.03,2.03,0,0,1-.9,2.336,1.586,1.586,0,0,1-.828.257Z",
	transform: "translate(-226.974 -357.765)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_530",
	"data-name": "Path 530",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034ZM218.045,401.061a6.482,6.482,0,0,0-6.475,6.475v56.6a6.482,6.482,0,0,0,6.475,6.475H321.117a6.5,6.5,0,0,0,6.474-6.38l.64-43.759a6.475,6.475,0,0,0-6.474-6.57H252.293a5.259,5.259,0,0,1-3.543-1.368l-13.7-9.786a6.461,6.461,0,0,0-4.364-1.691Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#3f3d56"
}))), /* @__PURE__ */ React.createElement("g", {
	id: "Group_16",
	"data-name": "Group 16",
	transform: "translate(40.44 -96.892)"
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_14-2",
	"data-name": "Group 14",
	transform: "translate(1065.56 383.947)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_499-2",
	"data-name": "Path 499",
	d: "M442.2,381.61a.756.756,0,0,0-.372.13,11.107,11.107,0,0,0,1.665-.231Z",
	transform: "translate(-393.645 -331.766)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_501-2",
	"data-name": "Path 501",
	d: "M364.676,494.922",
	transform: "translate(-332.608 -421.489)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_507-2",
	"data-name": "Path 507",
	d: "M427.115,497.083h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -421.044)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_508-2",
	"data-name": "Path 508",
	d: "M432.732,519.086H384.245a1.362,1.362,0,1,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -438.452)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_509-2",
	"data-name": "Path 509",
	d: "M427.115,569.656h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-347.013 -478.459)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_510-2",
	"data-name": "Path 510",
	d: "M432.732,591.659H384.245a1.362,1.362,0,0,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -495.866)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_517-2",
	"data-name": "Path 517",
	d: "M125.842,339.408H128.4l1.218-9.877h-3.78Z",
	transform: "translate(-99.556 -260.701)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_518-2",
	"data-name": "Path 518",
	d: "M333.868,516.174h5.043a3.214,3.214,0,0,1,3.214,3.214v.1h-8.257Z",
	transform: "translate(-308.235 -438.302)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_519-2",
	"data-name": "Path 519",
	d: "M30.551,330.254l2.653.519,3.264-9.986-3.916-.766Z",
	transform: "translate(-24.169 -253.177)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_520-2",
	"data-name": "Path 520",
	d: "M236.727,507.59l5.225,1.022h0a3.393,3.393,0,0,1,2.678,3.981l-.021.108-8.555-1.673Z",
	transform: "translate(-230.853 -431.511)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_526-2",
	"data-name": "Path 526",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_527-2",
	"data-name": "Path 527",
	d: "M336.023,478.554H234.477a3.329,3.329,0,0,1-3.325-3.325V417.7a3.329,3.329,0,0,1,3.325-3.325,2.944,2.944,0,0,1,2.941,2.941V471.26a3.12,3.12,0,0,0,3.116,3.116H335.68a2.115,2.115,0,0,1,2.071,1.585,2.03,2.03,0,0,1-.9,2.336,1.586,1.586,0,0,1-.828.257Z",
	transform: "translate(-226.974 -357.765)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_530-2",
	"data-name": "Path 530",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034ZM218.045,401.061a6.482,6.482,0,0,0-6.475,6.475v56.6a6.482,6.482,0,0,0,6.475,6.475H321.117a6.5,6.5,0,0,0,6.474-6.38l.64-43.759a6.475,6.475,0,0,0-6.474-6.57H252.293a5.259,5.259,0,0,1-3.543-1.368l-13.7-9.786a6.461,6.461,0,0,0-4.364-1.691Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#3f3d56"
})))));
export default SvgNoFolders;
